document.querySelectorAll('[role="tablist"]').forEach((tablist) => {
  const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));

  tabs.forEach((tab) => {
    tab.addEventListener('click', () => activateTab(tab, tabs));
    tab.addEventListener('keydown', (e) => handleKeydown(e, tabs));
  });
});

function activateTab(tab, tabs) {
  tabs.forEach((t) => {
    const panel = document.getElementById(t.getAttribute('aria-controls'));
    const isActive = t === tab;
    t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    t.setAttribute('tabindex', isActive ? '0' : '-1');
    if (panel) panel.hidden = !isActive;
  });
  tab.focus();
}

function handleKeydown(e, tabs) {
  const index = tabs.indexOf(e.currentTarget);
  let next;

  if (e.key === 'ArrowRight') next = (index + 1) % tabs.length;
  else if (e.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
  else if (e.key === 'Home') next = 0;
  else if (e.key === 'End') next = tabs.length - 1;
  else return;

  e.preventDefault();
  activateTab(tabs[next], tabs);
}
